import { Link } from 'react-router-dom';
import styles from './MobileNavOverlay.module.css';
import { DownloadFreeButton } from '../shared/DownloadFreeButton';

interface MobileNavOverlayProps {
  links: { id: string; label: string; href: string }[];
  onClose: () => void;
  onNavClick?: (destination: string) => void;
}

export function MobileNavOverlay({ links, onClose, onNavClick }: MobileNavOverlayProps) {
  return (
    <div className={styles.overlay}>
      <button className={styles.close} onClick={onClose} aria-label="Close menu">
        &times;
      </button>
      <ul className={styles.list}>
        {links.map((l) => (
          <li key={l.id}>
            <Link
              to={l.href}
              className={styles.link}
              onClick={() => {
                onNavClick?.(l.href);
                onClose();
              }}
            >
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
      <div className={styles.cta}>
        <DownloadFreeButton />
      </div>
    </div>
  );
}
